// Utility functions for working with YouTube URLs

/**
 * Extracts the video ID from a YouTube URL
 * Supports various YouTube URL formats:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - VIDEO_ID (if already just an ID)
 */
export const extractVideoId = (url: string): string => {
  if (!url) return '';
  
  // If it's already just a video ID (no URL), return as is
  if (!url.includes('youtube.com') && !url.includes('youtu.be')) {
    return url;
  }
  
  // Extract video ID from various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  // If no pattern matches, return the original string
  return url;
};

/**
 * Converts a YouTube URL to an embed URL
 */
export const getEmbedUrl = (url: string): string => {
  const videoId = extractVideoId(url);
  return `https://www.youtube.com/embed/${videoId}`;
};
